import React from "react";
import SwipeableBottomSheet from "react-swipeable-bottom-sheet";
import Bar from "./Bar";
import colors from "../theme";
import { toHumanReadableSize } from "../util";

const LabelledBar = ({ label, percent, color }) => {
  const pct = percent > 0 ? Math.round(percent * 100) : 0;
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
      }}
    >
      <Bar
        style={{
          display: "flex",
          flexDirection: "row",
          flexGrow: 1,
          paddingTop: 5,
          paddingBottom: 5,
          marginRight: 4,
          color,
        }}
        percent={pct}
      />
      <div style={{ display: "flex" }}>
        <div
          style={{
            width: 30,
            color: colors.textHigh,
            // backgroundColor: 'red',
            fontSize: 12,
            textAlign: "right",
            marginRight: 4,
          }}
        >
          {pct}%
        </div>
        <div
          style={{
            width: 60,
            color: colors.textHigh,
            // backgroundColor: 'red',
            fontSize: 12,
          }}
        >
          {label}
        </div>
      </div>
    </div>
  );
};

const Metric = ({ value, label, color }) => (
  <div style={styles.metricContainer}>
    <h1
      style={{
        color: colors.textMed,
        fontSize: 10,
        letterSpacing: 0.5,
        marginBottom: 4,
      }}
    >
      {label}
    </h1>
    <span style={{ color: color, fontSize: 22 }}>
      {value >= 0 ? toHumanReadableSize(value) : "-"}
    </span>
  </div>
);

const HorizontalRule = () => (
  <div
    style={{
      width: "100%",
      height: 1,
      backgroundColor: colors.surface04,
      marginBottom: 16,
    }}
  ></div>
);

const Section = ({ title, children }) => (
  <div style={{ marginTop: 16, marginBottom: 16 }}>
    <HorizontalRule />
    <h1 style={{ color: colors.textHigh, fontSize: 14, marginBottom: 16 }}>
      {title}
    </h1>
    {children}
  </div>
);

const Attribution = ({ isMobile }) => (
  <>
    <div style={{ color: colors.textLow2, fontSize: 12 }}>
      built by{" "}
      <a
        className="ilink"
        href="https://mirailabs.io"
        target="_blank"
        rel="noopener noreferrer"
      >
        <b>mirai labs</b>
      </a>
    </div>
    <div style={{ color: colors.textLow3, fontSize: 10, marginTop: 8 }}>
      {"Data derived from the "}
      <a
        className="link"
        href="https://github.com/CSSEGISandData/COVID-19"
        target="_blank"
        rel="noopener noreferrer"
      >
        COVID-19 Data Repository at Johns Hopkins University
      </a>
      {". "}
    </div>
    {isMobile && (
      <div style={{ color: colors.textLow3, fontSize: 10 }}>
        {"Map built with "}
        <a
          className="link"
          href="https://leafletjs.com"
          title="A JS library for interactive maps"
          target="_blank"
          rel="noopener noreferrer"
        >
          Leaflet
        </a>
        {" using tiles "}
        &copy;{" "}
        <a
          className="link"
          href="https://www.openstreetmap.org/copyright"
          target="_blank"
          rel="noopener noreferrer"
        >
          OpenStreetMap
        </a>{" "}
        contributors &copy;{" "}
        <a
          className="link"
          href="https://carto.com/attributions"
          target="_blank"
          rel="noopener noreferrer"
        >
          CARTO
        </a>
        {"."}
      </div>
    )}
  </>
);

const BottomSheetGrip = () => (
  <div style={styles.gripContainer}>
    <div style={styles.gripHandle} />
  </div>
);

const DetailView = ({
  region,
  confirmed,
  dead,
  recovered,
  active,
  lastUpdate,
  loading,
  error,
  isMobile,
}) => (
  <div className="detail-sheet">
    {isMobile && <BottomSheetGrip />}
    <header>
      <h1
        style={{
          color: colors.textHigh,
          fontSize: 20,
          paddingBottom: 16,
          marginBottom: 0,
        }}
      >
        {region}
        {loading && <div className="loader" />}
      </h1>

      <div style={styles.container}>
        <Metric label={"TOTAL"} value={confirmed} color={colors.textHigh} />
        <Metric label={"ACTIVE"} value={active} color={colors.yellow} />
        <Metric label={"DEAD"} value={dead} color={colors.red} />
        <Metric label={"RECOVERED"} value={recovered} color={colors.green} />
      </div>
    </header>

    <Section title={"Cases by category"}>
      <LabelledBar
        label={`active`}
        percent={active / confirmed}
        color={colors.yellow}
      />
      <LabelledBar
        label={`dead`}
        percent={dead / confirmed}
        color={colors.red}
      />
      <LabelledBar
        label={`recovered`}
        percent={recovered / confirmed}
        color={colors.green}
      />
    </Section>

    <footer>
      {lastUpdate && (
        <div style={{ color: colors.textLow2, fontSize: 12 }}>
          last update: {new Date(lastUpdate).toLocaleString()}
        </div>
      )}
      <Attribution isMobile={isMobile} />
    </footer>
  </div>
);

const DetailSheet = (props) => {
  return (
    <>
      {/* Mobile */}
      <div className="bottom-sheet">
        <SwipeableBottomSheet
          style={{ zIndex: 1 }}
          bodyStyle={{
            padding: 16,
            backgroundColor: colors.bottomSheetBackground,
          }}
          overflowHeight={140}
          overlay={false}
        >
          <DetailView {...props} isMobile={true} />
        </SwipeableBottomSheet>
      </div>
      {/* Desktop */}
      <div
        className="side-sheet shadow"
        style={{ backgroundColor: colors.sideSheetBackground }}
      >
        <DetailView {...props} />
      </div>
    </>
  );
};

const styles = {
  container: {
    display: "flex",
    flex: 1,
    flexDirection: "row",
    marginBottom: 16,
    alignItems: "center",
  },
  metricContainer: {
    flex: 1,
  },
  gripContainer: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: colors.bottomSheetBackground,
    paddingBottom: 4,
  },
  gripHandle: {
    width: 24,
    height: 4,
    borderRadius: 4,
    backgroundColor: "#ffffff44",
  },
};

export default DetailSheet;
